import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, size = 18, readOnly = false, testId }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      {stars.map((s) => {
        const filled = s <= Math.round(value);
        return (
          <button
            type="button"
            key={s}
            disabled={readOnly}
            onClick={() => onChange && onChange(s)}
            className={`p-0.5 rounded transition-transform ${
              readOnly ? "cursor-default" : "hover:scale-110 cursor-pointer"
            }`}
            data-testid={`star-${s}`}
            aria-label={`${s} étoile${s > 1 ? "s" : ""}`}
          >
            <Star
              size={size}
              className={filled ? "fill-brand-terracotta text-brand-terracotta" : "text-brand-line"}
              strokeWidth={1.5}
            />
          </button>
        );
      })}
    </div>
  );
}
